import React from 'react'
import Collapse from '@dustin-web/microsite-components/src/collapse'
import { collapseColorTheme } from '@dustin-web/microsite-components/src/collapse/collapse'
import { type Parser, domParser } from '.'

export const collapseParser: Parser = (node, additionalMacros, additionalNodeParsers) => {
  if (node.type === 'tag' && node.attribs['data-component']?.includes('collapse')) {
    const children = domParser(node.children, additionalMacros, additionalNodeParsers)

    const characterLimit = node.attribs['data-characterlimit']
      ? parseInt(node.attribs['data-characterlimit'])
      : 450
    const colorTheme =
      node.attribs['data-color'] && node.attribs['data-color'].match('gray|white')
        ? (node.attribs['data-color'] as collapseColorTheme)
        : 'gray'

    if (!children) {
      return null
    }

    return (
      <Collapse colorTheme={colorTheme} characterLimit={characterLimit}>
        {children}
      </Collapse>
    )
  } else {
    return
  }
}
